module.exports = __webpack_public_path__ + "img/icone_word.e24121d6.png";